var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"auth-nav-container"},[(_vm.currentUser === null)?_c('SignOnPopup'):_vm._e(),(_vm.currentUser !== null)?_c('Avatar',{attrs:{"user":_vm.currentUser}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }